import { buildRoute } from '@direct-frontend/modules-router';

export const checkoutEditorRoute = buildRoute('/checkout-editor');
